// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"Loader_spinnerWrapper__23zwU","spinner":"Loader_spinner__33atC","spin":"Loader_spin__2LMOE"};